import React from "react";
import "./Clients.css";

import tata from './images/tata.jpg';
import bmw from './images/bmw1.webp';
import reliance from './images/reliance.jpg';
import subway from './images/subway.jpg';
import ferrero from './images/ferrero.jpg';
import shrike from './images/shrike.jpg';
import mahindra from './images/mahindra.jpg';
import man from './images/man.jpg';
import icici from './images/icici.jpg';
import adient from './images/adient.jpg';
import lot from './images/lot.jpg';
import hdfc from './images/hdfc.jpg';

import emerson from './images/emerson.jpg';
import brintons from './images/brintons.jpg';
import box8 from './images/box8.jpg';
import godrej from './images/godrej.jpg';
import nitor from './images/nitor.jpg';
import reflexsis from './images/reflexsis.jpg';
import yardi from './images/yardi.jpg';
import capita from './images/capita.jpg';
import clearpoint from './images/clearpoint.jpg';
import aam from './images/aam.jpg';
import aishwaryam from './images/aishwaryam.jpg';
import glatt from './images/glatt.jpg';

import allianz from './images/allianz.jpg';
import opus from './images/opus.jpg';
import fev from './images/fev.jpg';
import bv from './images/bv.jpg';
import cahors from './images/cahors.jpg';
import yazaki from './images/yazaki.jpg';
import hdfcergo from './images/hdfcergo.jpg';
import tatabatteries from './images/tatabatteries.jpg';
import harbinger from './images/harbinger.jpg';
import dynapac from './images/dynapac.jpg';
import alphalaval from './images/alphalaval.jpg';
import jonky from './images/jonky.jpg';

const Clients = () => {

  const logos = [
    tata, bmw, reliance, subway, ferrero, shrike, mahindra, man, icici,
    adient, lot, hdfc, emerson, brintons, box8, godrej, nitor, reflexsis,
    yardi, capita, clearpoint, aam, aishwaryam, glatt,
    allianz, opus, fev, bv, cahors, yazaki, hdfcergo,
    tatabatteries, harbinger, dynapac, alphalaval, jonky
  ];

  //  SPLIT LOGOS INTO 2 ROWS
  const firstRow = logos.slice(0, 18);
  const secondRow = logos.slice(18);

  return (
    <div className="clients-section">

      <div className="container text-center">
        <h2> — Trusted by Leading Brands — </h2>
        <p>Serving <b>1500+ clients</b> across industries</p>
      </div>

      {/* ROW 1 → LEFT */}
      <div className="marquee">
        <div className="marquee-track left">
          {[...firstRow, ...firstRow].map((img, i) => (
            <div className="logo-box" key={i}>
              <img src={img} alt="client" />
            </div>
          ))}
        </div>
      </div>

      {/* ROW 2 → RIGHT */}
      <div className="marquee">
        <div className="marquee-track right">
          {[...secondRow, ...secondRow].map((img, i) => (
            <div className="logo-box" key={i}>
              <img src={img} alt="client" />
            </div>
          ))}
        </div>
      </div>

    </div>
  );
};

export default Clients;